import React, {PureComponent} from "react"

import Form from "@irati/ui/src/Form"
import {Select} from "@irati/ui/src/FormItem"
import {injectIntl, InjectIntl} from "@irati/utils/lang"
import teamService from "@irati/identity/services/teams"

const BASIC_ASSIGNMENT = "Basic"
const MANAGER_ASSIGNMENT = "Manager"

interface Props extends InjectIntl {
  value: string
  teamId: string
  userId: string
}

class TeamAccessLevel extends PureComponent<Props> {
  state = {
    value: BASIC_ASSIGNMENT
  }

  componentDidMount() {
    const {value} = this.props
    this.setState({value})
  }

  handleChange = (value: string) => {
    const {teamId, userId} = this.props
    teamService.addUserToTeam(teamId, userId, value)
    this.setState({value})
  }

  buildOptions = () => {
    const {formatMessage} = this.props

    return [
      {value: BASIC_ASSIGNMENT, label: formatMessage({id: "platform.fields.teamAccessLevel.member.label"})},
      {value: MANAGER_ASSIGNMENT, label: formatMessage({id: "platform.fields.teamAccessLevel.teamManager.label"})}
    ]
  }

  render() {
    const {value} = this.state

    return (
      <Form>
        <Select value={value} options={this.buildOptions()} isClearable={false} onChange={this.handleChange} />
      </Form>
    )
  }
}

export default injectIntl(TeamAccessLevel)
